"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _invalidPropertyException = _interopRequireDefault(require("../exception/invalid-property-exception"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var Config = /*#__PURE__*/function () {
  function Config() {
    var _this = this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Config);

    this.data = {};

    if (_typeof(config) !== "object") {
      throw new _invalidPropertyException["default"]("Config must be an object or array");
    }

    Object.keys(config).forEach(function (key) {
      if (_typeof(config[key]) !== "object") {
        _this.data[key] = config[key];
        return;
      }

      _this.data[key] = new Config(config[key]);
    }, this);
  }

  _createClass(Config, [{
    key: "get",
    value: function get(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (this.has(key)) {
        return this.data[key];
      }

      if (key.indexOf(".") === -1) {
        return defaultValue;
      }

      return this.getFromObject(key, defaultValue);
    }
  }, {
    key: "getFromObject",
    value: function getFromObject(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      /* eslint-disable sort-vars */

      var keys = key.split(".");
      var keyLens = keys.length - 1;
      /* eslint-disable consistent-this */

      var tempConfig = this;
      var myReturn = null;

      for (var iteration = 0; iteration <= keyLens; iteration += 1) {
        if (iteration === keyLens) {
          myReturn = tempConfig.get(keys[iteration], defaultValue);
          break;
        }

        tempConfig = tempConfig.get(keys[iteration], new Config());
      }

      return myReturn;
    }
  }, {
    key: "has",
    value: function has(key) {
      return typeof this.data[key] !== "undefined";
    }
  }]);

  return Config;
}();

exports["default"] = Config;